var _ = require('underscore');

// Updated to accept projectData and codesData directly
// codesData is already a flat array with level information from useCodeSidebarCodes
const codeListMapper = (projectData, codesData) => {
  // Map the flat array of codes to the export format
  const codes = (codesData || []).map((code, index) => {
    // Build the code's URL - just use code.id
    const host = window?.location?.host || "app.delvetool.com";
    const url = `https://${host}/projects/${projectData.id}/codes/${code.id}`;
    
    // Process synthesis text
    const synthesis = code.synthesis || '';
    const synthesisArray = synthesis.split('\n').filter(line => !!line && line.length > 0);
    
    // Use the level from the code object (already calculated by useCodeSidebarCodes)
    const level = code.level || 1;
    
    // Create the row for this code
    return [
      code.id,
      index + 1, // Order in list (1-based)
      '>'.repeat(level),
      code.name,
      code.count || 0,
      synthesisArray.join('\n'),
      url
    ];
  });
  
  return {
    codes
  };
}

export default codeListMapper;
